var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-os" },
    [
      [
        _c(
          "el-steps",
          {
            staticClass: "mt-20 mb-40",
            attrs: {
              active: _vm.indexTela,
              "finish-status": "success",
              "align-center": "align-center"
            }
          },
          [
            _vm.numero && _vm.edicao
              ? _c("el-step", {
                  attrs: {
                    title: "Adicionar/Remover processos",
                    icon: "el-icon-edit-outline"
                  }
                })
              : _c("el-step", {
                  attrs: {
                    title: "Adicionar processos",
                    icon: "el-icon-edit-outline"
                  }
                }),
            _c("el-step", {
              attrs: {
                title: "Dados da ordem de serviço",
                icon: "el-icon-tickets"
              }
            }),
            _c("el-step", {
              attrs: { title: "Função por equipe", icon: "el-icon-tickets" }
            })
          ],
          1
        )
      ],
      _c(
        "div",
        { attrs: { id: "scroll" } },
        [
          _c(
            "div",
            [
              _c(this.telas[_vm.indexTela].componente, {
                ref: "passoCadastro",
                tag: "component",
                attrs: {
                  usuario: _vm.usuario,
                  numero: _vm.numero,
                  edicao: _vm.edicao && _vm.primeiroPasso,
                  ordemServico: _vm.ordemServico,
                  analistas: _vm.analistas,
                  analistasSelecionados: _vm.analistasSelecionados,
                  buscar: _vm.buscar
                },
                on: { setOrdemServico: _vm.setOrdemServico }
              })
            ],
            1
          ),
          _c("app-button", {
            attrs: {
              isEtapaSalva: false,
              showButtonCancelar: _vm.primeiroPasso,
              showButtonProximo: !_vm.ultimoPasso,
              isPrimeiroPasso: _vm.primeiroPasso,
              isUltimoPasso: _vm.ultimoPasso
            },
            on: {
              proximo: _vm.proximo,
              voltar: _vm.anterior,
              cancelar: _vm.cancelar,
              finalizar: _vm.finalizar
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19d2e95c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19d2e95c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/ordemServico/OrdemServico.vue
// module id = null
// module chunks = 